export default __webpack_public_path__ + "static/media/logo.fe5dfced.png";